import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectPatchingUserFromState = (state: RootState): boolean =>
  state.app.profile.profileInfo.patchingUser
export const selectPatchingUserProfileFromState = (state: RootState): boolean =>
  state.app.profile.profileInfo.patchingUserProfile
export const selectPatchingUserEmployeeFromState = (
  state: RootState,
): boolean => state.app.profile.profileInfo.patchingUserEmployee
export const selectPatchingUserLocaleFromState = (state: RootState): boolean =>
  state.app.profile.profileInfo.patchingUserLocale
export const selectPatchingUserCurrencyFromState = (
  state: RootState,
): boolean => state.app.profile.profileInfo.patchingUserCurrency
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.profile.profileInfo.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.profile.profileInfo.errorDetailMap
